import React, {FC} from "react"
import {FUNDING, PayPalButtons, PayPalButtonsComponentProps, PayPalScriptProvider} from "@paypal/react-paypal-js"
import {PaymentCurrencyType, PaymentMethodConfigs} from "@irati/types"

interface Props {
  currency: PaymentCurrencyType
  paymentMethodConfigs: PaymentMethodConfigs
  load?: Promise<any>
}

const PayPal: FC<Props> = ({paymentMethodConfigs, currency, load}) => {
  const payPalOptions = {
    clientId: paymentMethodConfigs.extId!,
    currency,
    intent: "capture"
  }

  return (
    <PayPalScriptProvider options={payPalOptions}>
      <PayPalButtons
        disabled={!!load}
        createOrder={async () => {
          // TODO: Get payment context
          // TODO: params:
          // source = "paypal"
          // amount
          // currency
          // returnUrl
          // paymentOrderId
          console.log("=== create order ===")
          return "aiusfisdu"
        }}
        onClick={async (data, actions) => {
          console.log("=== onclick ===")
          // return actions.reject()}
          return actions.resolve()
        }}
        onError={(e) => {
          console.log("=== e ===", e)
        }}
        style={payPalStyle}
        fundingSource={FUNDING.PAYPAL}
        onApprove={async (data, actions) => {
          // if approved, we have user authorisation to get their money
          console.log("=== data ===", data)
          // TODO: trigger requestPayment
          return actions.redirect("urlToSuccessPage")
        }}
      />
    </PayPalScriptProvider>
  )
}

export default PayPal

// Update .stylelintignore if moving the style below or lint:css will fail
const payPalStyle: PayPalButtonsComponentProps["style"] = {
  layout: "vertical",
  color: "gold",
  shape: "rect",
  label: "paypal"
}
